export const GET_STORES_BEGIN = 'GET_STORES_BEGIN'
export const GET_STORES_SUCCESS = 'GET_STORES_SUCCESS'
export const GET_STORES_ERROR = 'GET_STORES_ERROR'

export const DELETE_STORE_BEGIN = 'DELETE_STORE_BEGIN'
export const DELETE_STORE_SUCCESS = 'DELETE_STORE_SUCCESS'
export const DELETE_STORE_ERROR = 'DELETE_STORE_ERROR'